import React from "react";
import { DAY_OPTIONS } from "./zahlungsplanUtils";

const ZahlungsplanHeader = ({ settings, onChange, readOnly, hideEmptyWeeks, onToggleHideEmpty, uniquePlaners = [], selectedPlaner, onSelectPlaner }) => {
  const handleChange = (field, value) => {
    onChange((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="zp-global-settings">
      <div className="zp-setting">
        <label>Nebenkosten (%)</label>
        <input
          type="number"
          step="0.1"
          value={settings.nebenkostenSatz}
          onChange={(e) => handleChange("nebenkostenSatz", parseFloat(e.target.value) || 0)}
          disabled={readOnly}
        />
      </div>
      <div className="zp-setting">
        <label>MwSt-Satz (%)</label>
        <input
          type="number"
          step="0.1"
          value={settings.mwstSatz}
          onChange={(e) => handleChange("mwstSatz", parseFloat(e.target.value) || 0)}
          disabled={readOnly}
        />
      </div>
      <div className="zp-setting">
        <label>Zahlungsfrist (Tage)</label>
        <input
          type="number"
          value={settings.zahlungsfrist}
          onChange={(e) => handleChange("zahlungsfrist", parseInt(e.target.value) || 0)}
          disabled={readOnly}
        />
      </div>
      <div className="zp-setting">
        <label>Rechnungstag</label>
        <select
          value={settings.rechnungstag}
          onChange={(e) => handleChange("rechnungstag", parseInt(e.target.value))}
          disabled={readOnly}
        >
          {DAY_OPTIONS.map((d) => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
      </div>
      <div className="zp-setting">
        <label>Rechnungsnr.-Prefix</label>
        <input
          type="text"
          value={settings.rechnungsnummerPrefix}
          onChange={(e) => handleChange("rechnungsnummerPrefix", e.target.value)}
          disabled={readOnly}
          style={{ width: "80px" }}
        />
      </div>
      {uniquePlaners.length > 0 && (
        <div className="zp-setting zp-planer-filter">
          <label>Planer</label>
          <select
            value={selectedPlaner ? selectedPlaner.id : ""}
            onChange={(e) => {
              const id = e.target.value;
              if (!id) {
                onSelectPlaner(null);
              } else {
                const planer = uniquePlaners.find((p) => String(p.id) === id);
                if (planer) onSelectPlaner(planer);
              }
            }}
          >
            <option value="">Alle</option>
            {uniquePlaners.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="zp-setting zp-filter-toggle">
        <button
          className={`zp-filter-btn ${hideEmptyWeeks ? "active" : ""}`}
          onClick={onToggleHideEmpty}
          title={hideEmptyWeeks ? "Alle Wochen anzeigen" : "Leere Wochen ausblenden"}
        >
          {hideEmptyWeeks ? "Alle KW" : "Leere KW ausblenden"}
        </button>
      </div>
    </div>
  );
};

export default ZahlungsplanHeader;
